import { AUDIO_TYPE } from "./../ricos-content/index.js";
const audioButtonsTypes = { audio: "audio", soundCloud: "soundCloud", spotify: "spotify" };
export {
  AUDIO_TYPE,
  audioButtonsTypes
};
//# sourceMappingURL=types.js.map
